<template>
  <div>
    <div
      class="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4"
      v-if="errors.non_field_errors"
    >
      <el-alert
        title="Error"
        type="error"
        description="The link you followed isn't working."
        :closable="false"
        show-icon
      >
      </el-alert>
    </div>
    <div
      v-else
      class="coupon col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4"
    >
      <div
        class="d-flex align-items-center justify-content-center p-5"
        v-if="dataLoading"
      >
        <div class="loader w-100"></div>
      </div>
      <div v-else>
        <div
          class="d-flex align-items-center justify-content-between px-3 pt-3"
        >
          <div class="d-flex flex-column">
            <h3>{{ coupon.title }}</h3>
            <span>price with coupon</span>
          </div>
          <div>
            <h2>${{ coupon.sale_price }}</h2>
          </div>
        </div>
        <el-divider></el-divider>
        <div class="d-flex px-4 justify-content-between">
          <div class="d-flex flex-column">
            <span><b>Claimed by</b></span>
            <span><b>Offered by</b></span>
            <span><b>Member ID</b></span>
            <span><b>Coupon ID</b></span>
          </div>
          <div class="d-flex flex-column">
            <span>{{ user.first_name }} {{ user.last_name }}</span>
            <span>{{ coupon.page.info.title }}</span>
            <span>{{ user.id.substr(user.id.length - 16) }}</span>
            <span>{{ coupon.id.substr(coupon.id.length - 16) }}</span>
          </div>
        </div>
        <el-divider></el-divider>
        <div
          class="d-flex justify-content-center align-items-center flex-column px-4 pb-4"
        >
          <el-alert
            :title="!redeemable && success ? 'Approved' : message"
            :description="!redeemable && success ? message : null"
            :type="success ? 'success' : 'warning'"
            :closable="false"
            :show-icon="true"
          >
          </el-alert>
          <el-button
            class="mt-3"
            :loading="redeemLoading"
            icon="el-icon-check"
            @click="approveCoupon"
            v-if="redeemable"
            type="success"
            >Approve</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: ["couponId", "userId"],
  data() {
    return {
      dataLoading: true,
      coupon: null,
      user: null,
      errors: {},
      message: "",
      success: false,
      redeemable: false,
      redeemLoading: false
    };
  },
  computed: {
    ...mapState("auth", ["accessToken"]),
  },
  methods: {
    loadCoupon() {
      this.errors = {};
      this.dataLoading = true;
      this.$http
        .get("pages/coupons/redeem", {
          params: { coupon: this.couponId, user: this.userId },
          headers: { Authorization: `Bearer ${this.accessToken}` },
        })
        .then(
          (response) => {
            this.coupon = response.body.data;
            this.user = response.body.user;
            this.message = response.body.message;
            this.success = response.body.success;
            this.redeemable = response.body.success;
            this.dataLoading = false;
          },
          (response) => {
            this.errors.non_field_errors = response.body.non_field_errors;
            this.redeemable = false;
            this.dataLoading = false;
          }
        );
    },
    approveCoupon() {
      this.errors = {};
      this.redeemLoading = true;
      this.$http
        .post(
          "pages/coupons/redeem",
          {},
          {
            params: { coupon: this.couponId, user: this.userId },
            headers: { Authorization: `Bearer ${this.accessToken}` },
          }
        )
        .then(
          (response) => {
            this.success = response.body.success;
            this.message = response.body.message;
            this.redeemable = false;
            this.redeemLoading = false;
          },
          (response) => {
            this.redeemable = false;
            this.redeemLoading = false;
            this.errors.non_field_errors = response.body.non_field_errors;
          }
        );
    },
  },
  created() {
    this.loadCoupon();
  },
};
</script>
<style lang="scss">
.coupon {
  background: white;
  border: 1px dashed black;
  border-radius: 12px;
}

.loader {
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
